document.addEventListener('DOMContentLoaded', function () {

  const items = document.querySelectorAll('.faq-s__item')

  items.forEach(item => {

    const question = item.querySelector('.faq-s__question')
    const answer = item.querySelector('.faq-s__answer')

    if (item.classList.contains('is-active')) {
      answer.style.height = answer.scrollHeight + 'px'
      answer.style.opacity = '1'
    }

    question.addEventListener('click', function () {

      const isActive = item.classList.contains('is-active')

      items.forEach(el => {
        el.classList.remove('is-active')
        const elAnswer = el.querySelector('.faq-s__answer')
        elAnswer.style.height = 0
        elAnswer.style.opacity = 0
      })

      if (!isActive) {
        item.classList.add('is-active')
        answer.style.height = answer.scrollHeight + 'px'
        answer.style.opacity = '1'
      }

    })

  })

})